<template>
  <w-settings-content-template>
    <el-tabs slot="content" type="card" v-model="activeTab">
      <el-tab-pane label="수집 설정" name="WObjCollectSetting" class="h100 w100">
        <w-obj-collect-setting></w-obj-collect-setting>
      </el-tab-pane>
      <el-tab-pane label="정책 설정" name="WTrapCollectSetting" class="h100 w100">
        <w-trap-collect-setting :active-tab="activeTab"></w-trap-collect-setting>
      </el-tab-pane>
    </el-tabs>
  </w-settings-content-template>
</template>

<script>
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import WObjCollectSetting from './ObjCollectSetting';
import WTrapCollectSetting from './TrapCollectSetting';

export default {
  name: 'WSnmptrapSettings',
  components: {
    WSettingsContentTemplate,
    WObjCollectSetting,
    WTrapCollectSetting,
  },
  data() {
    return {
      activeTab: 'WObjCollectSetting',
    };
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Collect/SnmpTrap/index.vue